import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import CWINFOSeller from "../components/changeOwnership/change/information-seller/info-seller";
import CWProfile from "../components/changeOwnership/change/profile/cwProfile";
import CWPrefactor from "../components/changeOwnership/change/prefactor/cwPrefactor";
import CWFinal from "../components/changeOwnership/change/final/cwFinal";
import CWSwapDocument from "../components/changeOwnership/change/swapDocument/cwSwapDocument";
import CWDocument from "../components/changeOwnership/change/document/cwDocument";
import CWReport from "../components/changeOwnership/reports/report-list/cw-report";
import CWListPendingDocument from "../components/changeOwnership/pending/list/cwListPendingDocument";
import CWPendingDocument from "../components/changeOwnership/pending/document/cwPendingDocument";

export const changeOwnershipRoutes = [
	// انتقال مالکیت
	<Route
		key="cw-information-seller"
		path={
			_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.InformationSeller
		}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWINFOSeller} />}
	/>,
	<Route
		key="cw-profile"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Profile}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWProfile} />}
	/>,
	<Route
		key="cw-swap-document"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.SwapDocument}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWSwapDocument} />}
	/>,
	<Route
		key="cw-prefactor"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Prefactor}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWPrefactor} />}
	/>,
	<Route
		key="cw-document"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Document}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWDocument} />}
	/>,
	<Route
		key="cw-final"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Final}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWFinal} />}
	/>,

	// گزارش تغییر مالکیت
	<Route
		key="cw-report"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Report.Index + _adr.ChangeOwnerShip.Report.List}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_Report_One} element={CWReport} />}
	/>,

	// در انتظار آپلود مدارک
	<Route
		key="cw-pending-list"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.List}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_Report_UploadingDoc} element={CWListPendingDocument} />}
	/>,
	<Route
		key="cw-pending-upload"
		path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.upload}
		element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_Report_UploadingDoc} element={CWPendingDocument} />}
	/>,
];
